import { render } from "./CartPage.vue?vue&type=template&id=cd166448&scoped=true"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"

import "./CartPage.vue?vue&type=style&index=0&id=cd166448&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd166448"]])

export default __exports__